import { WIZARD_DATA_RECEIVED, WIZARD_DATA_UNLOADED } from './types';
import api from 'api';

export const wizardDataUnload = () => ({
  type: WIZARD_DATA_UNLOADED
})

export const wizardDataReceived = (data) => ({
  type: WIZARD_DATA_RECEIVED,
  data
})

export const unloadWizard = () => dispatch => {
  dispatch(wizardDataUnload())
}

export const getWizardLifestyle = () => (dispatch) =>
  api.bmc.wizard.getWizardLifestyle().then(res => {
  dispatch(wizardDataReceived(res))
});